import * as actionTypes from '../types/report';

export function getListReports(payload) {
  return {
    type: actionTypes.GET_LIST_REPORTS,
    payload
  };
}

export function getListReportsSuccess(payload) {
  return {
    type: actionTypes.GET_LIST_REPORTS_SUCCESS,
    payload
  };
}

export function getListReportsFail(payload) {
  return {
    type: actionTypes.GET_LIST_REPORTS_FAIL,
    payload
  };
}

export function getReportCreate(payload) {
  return {
    type: actionTypes.GET_REPORT_CREATE,
    payload
  };
}
export function getReportCreateNew(payload) {
  return {
    type: actionTypes.GET_REPORT_CREATE_NEW,
    payload
  };
}

export function getReportCreateSuccess(payload) {
  return {
    type: actionTypes.GET_REPORT_CREATE_SUCCESS,
    payload
  };
}

export function setInitialStateReport(payload) {
  return {
    type: actionTypes.SET_INITIAL_STATE_REPORT,
    payload
  };
}

export function getReportCreateFail(payload) {
  return {
    type: actionTypes.GET_REPORT_CREATE_FAIL,
    payload
  };
}

export function getReportErrorClose(payload) {
  return {
    type: actionTypes.GET_REPORT_ERROR_CLOSE,
    payload
  };
}

export function getReportTypes(payload) {
  return {
    type: actionTypes.GET_REPORT_TYPES,
    payload
  };
}

export function getReportTypesSuccess(payload) {
  return {
    type: actionTypes.GET_REPORT_TYPES_SUCCESS,
    payload
  };
}

export function getReportTypesFail(payload) {
  return {
    type: actionTypes.GET_REPORT_TYPES_FAIL,
    payload
  };
}

export function getReportProductTypes(payload) {
  return {
    type: actionTypes.GET_REPORT_PRODUCT_TYPES,
    payload
  };
}

export function getReportProductTypesSuccess(payload) {
  return {
    type: actionTypes.GET_REPORT_PRODUCT_TYPES_SUCCESS,
    payload
  };
}

export function getReportProductTypesFail(payload) {
  return {
    type: actionTypes.GET_REPORT_PRODUCT_TYPES_FAIL,
    payload
  };
}

export function getReportUsers(payload) {
  return {
    type: actionTypes.GET_REPORT_USERS,
    payload
  }
}
export function getReportUsersSuccess(payload) {
  return {
    type: actionTypes.GET_REPORT_USERS_SUCCESS,
    payload
  }
}
export function getReportUsersFail(payload) {
  return {
    type: actionTypes.GET_REPORT_USERS_FAIL,
    payload
  }
}
